import React, { useState, useEffect } from "react";
import "../css/Videos.css";
import Slider from "react-slick"; // Assuming you have react-slick installed
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Videos = ({ resources }) => {
  useEffect(() => {
    // console.log("Updated resources in Videos:", resources);
  }, [resources]);

  const [showModal, setShowModal] = useState(false);
  const [selectItem, setSelectItem] = useState("");

  function convertToEmbedUrl(url) {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)([a-zA-Z0-9_-]{11})(?=\?|$)/;
    const match = url.match(regex);
    if (match && match[1]) {
      return `https://www.youtube.com/embed/${match[1]}`;
    }
    return url;
  }

  const handleItemClick = (_item) => {
    _item.url = convertToEmbedUrl(_item.url);
    setSelectItem(_item);
    console.log("setSelectItem", selectItem);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const CustomArrow = ({ className, style, onClick, src, alt }) => (
    <img
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
      src={src}
      alt={alt}
    />
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <CustomArrow src="../round_right_arrow.svg" alt="Right Arrow" />,
    prevArrow: <CustomArrow src="../round_left_arrow.svg" alt="Left Arrow" />,
    responsive: [
      {
        breakpoint: 768, // Adjust the breakpoint as needed
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="video-section videoContainer">
      <label className="video-title">Handpicked Videos</label>{" "}
      <span className="tag tag_video"> For You</span>
      {resources === null ? (
        <p>...loading</p>
      ) : resources.length === 0 ? (
        <p>No videos available</p>
      ) : (
        <Slider {...settings} className="video-section-container">
          {resources.map((resource) => (
            <div
              className="item-video"
              key={resource.title}
              onClick={() => handleItemClick(resource)}
            >
              <div className="item">
                <img
                  src={resource.thumbnail || "../videoPlaceholder.jpg"}
                  alt="Video Thumbnail"
                />
                <h3>{resource.title}</h3>
                <p>{resource.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      )}
      {showModal && (
        <div
          className="modal-lightbox"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
          onClick={handleCloseModal}
        >
          <div className="modal-content">
            <button
              className="modal-close-button"
              onClick={handleCloseModal}
              aria-label="Close"
            >
              ×
            </button>
            <iframe
              width="560"
              height="315"
              src={selectItem.url}
              title={selectItem.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default Videos;
